export default __webpack_public_path__ + "static/media/who_needs.b1fab3d2.svg";